import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSecurity = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-100.771q-129.769-35.384-214.884-152.768Q180.001-370.924 180.001-516v-230.153L480-858.46l299.999 112.307V-516q0 145.076-85.115 262.461Q609.769-136.155 480-100.771ZM480-164q97-30 162-118.5T718-480H480v-314.615L240-705v206.615Q240-491 242-480h238v316Z" })
});
export default SvgSecurity;
